import { Component, OnInit } from '@angular/core';
import { TranslatesService } from '../../../translates';
import { LocationManagerService } from '@cakeiteasy/web-utils';
import { DOMAIN_LANGUAGE_CODE_MAP } from '../../../translates/translates.service';

@Component({
  standalone: false,
  selector: 'language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  public codes = [{ label: 'EN', value: 'en' }];

  constructor(private _translation: TranslatesService,
              private _locationManager: LocationManagerService) {
  }

  ngOnInit() {
    const domain = this._locationManager.getDomainName();
    this.codes.unshift({ label: domain, value: DOMAIN_LANGUAGE_CODE_MAP[domain] });
  }

  public isActive(code) {
    return this._translation.getCurrentLang() === code;
  }

  public changeLanguage(code: string) {
    this._translation.changeLang(code);
  }
}
